// extracted by mini-css-extract-plugin
module.exports = {"overlay":"loading_overlay__M_wCH","spinner":"loading_spinner__dPMv1","rotate360":"loading_rotate360__amuLe"};